<template>
  <LcModal
    :background-class="$style['modal-background']"
    :close-triggers="['close-button', 'escape', 'click-outside']"
    :container-class="$style['modal-container']"
    :tracking="{ topicKey: 'scratchcard-image-modal' }"
    @close="emit('close')"
  >
    <template #modal="{ setRef }">
      <LcButton
        class="close-button"
        icon="close"
        size="small"
        variant="filled"
        @click="emit('close')"
      />

      <div class="image-container">
        <LcImage
          v-bind="{ src, ...properties }"
          :ref="setRef"
          :alt="$t(`scratchcard.slide.ticket.image.${name}.alt`)"
          :aspect-ratio="0"
          class="image"
          fetchpriority="high"
        />
      </div>
    </template>
  </LcModal>
</template>

<script lang="ts" setup>
import type { ImagePropertiesPayload } from '#api/shared/@types/generated/backend/graphql-schema-types'

type ScratchcardImageModalEmits = { (e: 'close'): void }

type ScratchcardImageModalProps = {
  name: string
  properties: ImagePropertiesPayload
  src: string
}

const emit = defineEmits<ScratchcardImageModalEmits>()

defineProps<ScratchcardImageModalProps>()
</script>

<style lang="scss" module>
.modal-background {
  overflow: hidden;
  padding: token('size/space/gap/none');
}

.modal-container {
  height: auto;
}
</style>

<style lang="scss" scoped>
.close-button {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  z-index: 1;
}

.image-container {
  justify-items: center;
  overflow: scroll;
  width: 100vw;
  height: 100vh;

  .image {
    padding: 3rem token('size/space/gap/300') 5rem;
  }
}
</style>
